import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./slices/authSlice";
import { popupModalSlice } from "./slices/popupModalSlices";
import { productSlice } from "./slices/productSlice";
import { citySlice } from "./slices/citySlice";
import { slotSlice } from "./slices/slotSlice";
import { carSlice } from "./slices/carSlice";
import { carWashSlice } from "./slices/carWashSlice";
import { slatsSlice } from "./slices/admin.slices/stats.slice";
import { bookingSlice } from "./slices/admin.slices/bookings.slice";
import { orderSlice } from "./slices/admin.slices/orders.slice";
import { usersSlice } from "./slices/admin.slices/users.slice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    popup: popupModalSlice.reducer,
    products: productSlice.reducer,
    city: citySlice.reducer,
    slots: slotSlice.reducer,
    myCars: carSlice.reducer,
    wash: carWashSlice.reducer,
    stats: slatsSlice.reducer,
    bookings: bookingSlice.reducer,
    orders: orderSlice.reducer,
    users: usersSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
